import 'ui-core/plugins/scrollo/js/scrollo';
(function () {
    if (typeof UX.scrollo !== 'undefined') {
        const scrollo = UX.scrollo;
        scrollo.get.fixedpageElementsHeight = function () {
            let elementsHeight = 0;
            const $fixedHeader = $('header.fixed');
            if ($fixedHeader.length) {
                elementsHeight = $fixedHeader.outerHeight();
            }

            const $stickyCoolbar = $('.actions-block-container');
            let stickyCoolbarHeigh = 0;
            if ($stickyCoolbar.length) {
                stickyCoolbarHeigh = $stickyCoolbar.outerHeight();
                elementsHeight += stickyCoolbarHeigh;
            }

            const $coolBarRes = $('.actionsbar__has__sections');
            if ($coolBarRes.length) {
                elementsHeight += $coolBarRes.outerHeight();
            }

            return elementsHeight;
        };
        UX.scrollo = scrollo;
    }
})();
